import React, { useState, useEffect } from "react";
import "./Billboards.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import billboard from "./images/billboard-clients.jpg";

const Billboards = () => {
  const [selectedBillboard, setSelectedBillboard] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(1);

  const billboards = [
    {
      id: 1,
      title: "Premium Highway Billboard",
      code: "HWY-001",
      description:
        "High-visibility billboard on major highway with excellent traffic flow",
      size: "14x48 ft",
      type: "Static",
      location: "Downtown Corridor",
      price: "$2,500/month",
      highway: "Interstate",
      traffic: "85,000 vehicles daily",
      availableFrom: "2023-10-01",
      availableTo: "2023-12-31",
      image: billboard,
    },
    {
      id: 2,
      title: "Digital City Center Billboard",
      code: "DCC-002",
      description:
        "Full-color digital display in the heart of the financial district",
      size: "20x30 ft",
      type: "Digital",
      location: "Financial District",
      price: "$4,200/month",
      highway: "City Streets",
      traffic: "120,000 vehicles daily",
      availableFrom: "2023-09-15",
      availableTo: "2023-12-15",
      image: billboard,
    },
    {
      id: 3,
      title: "Suburban Arterial Billboard",
      code: "SUB-003",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 4,
      title: "Suburban Arterial Billboard",
      code: "SUB-004",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 5,
      title: "Suburban Arterial Billboard",
      code: "SUB-005",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 6,
      title: "Suburban Arterial Billboard",
      code: "SUB-006",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 7,
      title: "Suburban Arterial Billboard",
      code: "SUB-007",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 8,
      title: "Suburban Arterial Billboard",
      code: "SUB-007",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 9,
      title: "Suburban Arterial Billboard",
      code: "SUB-007",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 10,
      title: "Suburban Arterial Billboard",
      code: "SUB-007",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
    {
      id: 11,
      title: "Suburban Arterial Billboard",
      code: "SUB-007",
      description: "Strategic placement on busy suburban arterial road",
      size: "12x25 ft",
      type: "Static",
      location: "Westside Suburbs",
      price: "$1,800/month",
      highway: "State Route",
      traffic: "45,000 vehicles daily",
      availableFrom: "2023-10-10",
      availableTo: "2024-01-10",
      image: billboard,
    },
  ];

  // حساب عدد الصفحات
  useEffect(() => {
    const total = Math.ceil(billboards.length / itemsPerPage);
    setTotalPages(total);
  }, [billboards.length, itemsPerPage]);

  // الحصول على الكروت للصفحة الحالية
  const getCurrentBillboards = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return billboards.slice(startIndex, endIndex);
  };

  // تغيير عدد العناصر المعروضة حسب حجم الشاشة
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(3);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(4);
      } else {
        setItemsPerPage(6);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  
  const openModal = (billboard) => {
    setSelectedBillboard(billboard);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedBillboard(null);
    document.body.style.overflow = "auto";
  };

  return (
    <div className="billboards-page">
      <NavBar />

      {/* Hero Section */}
      <section className="billboards-hero">
        <div className="hero-content container ">
          <h1>All Billboards</h1>
          <p>Discover our premium outdoor advertising locations</p>
        </div>
      </section>

      <div className="billboards-container">
        {getCurrentBillboards().map((billboard) => (
          <div key={billboard.id} className="billboard-card">
            <div className="card-image">
              <img src={billboard.image} alt={billboard.title} />
              <span className="availability-badge">Available</span>
            </div>
            <div className="card-content">
              <h3>
                {billboard.title}{" "}
                <span className="billboard-code">{billboard.code}</span>
              </h3>
              <p className="billboard-description">{billboard.description}</p>
              <ul className="billboard-info p-0">
                <li>
                  <strong>Size:</strong> {billboard.size}
                </li>
                <li>
                  <strong>Location:</strong> {billboard.location}
                </li>
                <li>
                  <strong>Highway:</strong> {billboard.highway}
                </li>
              </ul>
              <div className="price">{billboard.price}</div>
              <button
                className="view-details-btn"
                onClick={() => openModal(billboard)}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      {billboards.length > itemsPerPage && (
        <div className="pagination-controls">
          <button
            className="pagination-btn prev-btn"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            ‹ Previous
          </button>

          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="pagination-btn next-btn"
            onClick={nextPage}
            disabled={currentPage === totalPages}
          >
            Next ›
          </button>
        </div>
      )}

      {selectedBillboard && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>
              ✕
            </button>

            <div className="modal-image-full">
              <img
                src={selectedBillboard.image}
                alt={selectedBillboard.title}
              />
            </div>

            <div className="modal-details-scroll">
              <h2>{selectedBillboard.title}</h2>
              <p className="modal-description">
                {selectedBillboard.description}
              </p>

              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Size:</span>
                  <span className="detail-value">{selectedBillboard.size}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Type:</span>
                  <span className="detail-value">{selectedBillboard.type}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Location:</span>
                  <span className="detail-value">
                    {selectedBillboard.location}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Price:</span>
                  <span className="detail-value">
                    {selectedBillboard.price}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Highway:</span>
                  <span className="detail-value">
                    {selectedBillboard.highway}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Daily Traffic:</span>
                  <span className="detail-value">
                    {selectedBillboard.traffic}
                  </span>
                </div>
              </div>

              <div className="availability">
                <p>
                  <strong>Available from:</strong>{" "}
                  {selectedBillboard.availableFrom}
                </p>
                <p>
                  <strong>To:</strong> {selectedBillboard.availableTo}
                </p>
              </div>

              <button className="book-now-btn">Book This Billboard</button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Billboards;
